module.exports = __webpack_public_path__ + "img/Fomento Lector.6bb9e37d.svg";